<template>
 <div
  v-if="
   this.openTimeSlotForm || this.openExceptionForm || this.openBankHolidaysForm
  ">
  <div class="px-4 py-5 bg-white sm:p-6">
   <div class="mb-5 border-b border-gray-200">
    <div class="sm:flex sm:items-baseline">
     <h3 class="text-lg font-medium leading-6 text-gray-900 capitalize">
      {{
       this.openTimeSlotForm
        ? $t("callqueueTable.timeslot")
        : $t("callqueueTable.exception")
      }}
     </h3>
     <div v-if="this.openTimeSlotForm" class="mt-4 sm:mt-0 sm:ml-10">
      <nav class="flex -mb-px space-x-8">
       <a
        @click="this.switchTabs()"
        :class="[
         this.weekDay
          ? 'encom_primary_thin_border encom_ouvert_ticket_text'
          : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
         'whitespace-nowrap pb-4 px-1 border-b-2 font-medium text-sm cursor-pointer',
        ]">
        {{ $t("callqueueTable.weekday") }}
       </a>
       <a
        @click="this.switchTabs2()"
        :class="[
         this.specificDay
          ? 'encom_primary_thin_border encom_ouvert_ticket_text'
          : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
         'whitespace-nowrap pb-4 px-1 border-b-2 font-medium text-sm cursor-pointer',
        ]">
        {{ $t("callqueueTable.specificDate") }}
       </a>
      </nav>
     </div>
    </div>
   </div>
   <div class="md:grid md:grid-cols-3 md:gap-6">
    <div class="md:col-span-1">
     <p class="mt-1 text-sm text-gray-500">
      {{
       this.openTimeSlotForm
        ? $t("callqueueTable.formTimeSlotDescription") + "."
        : this.openExceptionForm
        ? $t("callqueueTable.formExceptionDescription") + "."
        : $t("callqueueTable.formExceptionTwelveMonthsDescription") + "."
      }}
     </p>
    </div>
    <div class="mt-5 md:mt-0 md:col-span-2">
     <form
      @submit.prevent="
       this.openTimeSlotForm
        ? createTimeSlot(
           $t('timeSlotAddedSuccessfully'),
           $t('unlinkCallQueue'),
           $t('unlinkCallQueueTitle', { type: $t('timeSlot') }),
           $t('createAndUnlink'),
           $t('cancel')
          )
        : this.openExceptionForm
        ? createException(
           $t('exceptionAddedSuccessfully'),
           $t('unlinkCallQueue'),
           $t('unlinkCallQueueTitle', { type: $t('exception') }),
           $t('createAndUnlink'),
           $t('cancel')
          )
        : createExceptionForBankHolidays(
           $t('exceptionAddedSuccessfully'),
           $t('unlinkCallQueue'),
           $t('unlinkCallQueueTitle', { type: $t('exception') }),
           $t('createAndUnlink'),
           $t('cancel')
          )
      "
      method="POST">
      <div class="grid grid-cols-6 gap-6">
       <div v-if="this.openTimeSlotForm && this.weekDay" class="col-span-3">
        <div class="flex inline">
         <label for="weekdays" class="block text-sm font-bold text-gray-700">{{
          $t("callqueueTable.weekday")
         }}</label>
         <fieldset class="ml-5">
          <legend class="sr-only">Notifications</legend>
          <div class="relative flex items-start">
           <div class="flex items-center h-6">
            <input
             v-model="this.checked"
             :value="checked"
             id="comments"
             aria-describedby="comments-description"
             name="comments"
             type="checkbox"
             class="w-4 h-4 border-gray-300 rounded focus:encom_border_input encom_ouvert_ticket_text" />
           </div>
           <div class="ml-2 text-sm">
            <label for="comments" class="text-gray-700 font-small">{{
             $t("callqueueTable.selectAllDays")
            }}</label>
           </div>
          </div>
         </fieldset>
        </div>
        <Menu>
         <MenuButton
          class="mt-1 relative text-left pl-3 p-1.5 w-full border border-gray-300 bg-white rounded focus:outline-none focus:encom_border_input sm:text-sm cursor-default"
          ><span class="block truncate"
           >{{ $t("callqueueTable.inputSelectDays") }}

           <kbd
            class="inline-flex items-center px-2 ml-1 font-sans text-sm font-medium text-gray-400 border border-gray-200 rounded">
            <svg
             xmlns="http://www.w3.org/2000/svg"
             class="w-3 h-3"
             fill="none"
             viewBox="0 0 24 24"
             stroke="currentColor">
             <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="3"
              d="M8 7l4-4m0 0l4 4m-4-4v18" />
            </svg>
            Shift
           </kbd>
           {{ $t("callqueueTable.or") }}
           <kbd
            class="inline-flex items-center px-2 ml-1 font-sans text-sm font-medium text-gray-400 border border-gray-200 rounded">
            Ctrl
           </kbd>
          </span>
          <span
           class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
           <SelectorIcon
            class="w-5 h-5 text-gray-400"
            aria-hidden="true" /> </span
         ></MenuButton>
         <transition
          enter-active-class="transition duration-100 ease-out"
          enter-from-class="transform scale-95 opacity-0"
          enter-to-class="transform scale-100 opacity-100"
          leave-active-class="transition duration-75 ease-in"
          leave-from-class="transform scale-100 opacity-100"
          leave-to-class="transform scale-95 opacity-0">
          <MenuItems>
           <select
            v-model="this.form.dayOfWeek"
            id="weekdays"
            name="weekdays"
            required
            multiple
            class="block w-full px-3 py-2 mt-1 capitalize bg-white border border-gray-300 sm:text-sm">
            <option
             v-for="dayOfWeek in weekDays"
             :key="dayOfWeek.id"
             :value="dayOfWeek.id">
             {{ $t(dayOfWeek.day) }}
            </option>
           </select>
          </MenuItems>
         </transition>
        </Menu>
       </div>
       <div
        v-else-if="this.openTimeSlotForm && this.specificDay"
        class="grid grid-cols-10 col-span-6">
        <div class="col-span-5 capitalize mr-7">
         <v-date-picker
          :min-date="new Date()"
          :attributes="attributes"
          :locale="$i18n.locale"
          @dayclick="onDayClick"
          title-position="left"
          trim-weeks
          is-expanded
          color="teal">
         </v-date-picker>
        </div>

        <div class="col-span-5 col-start-6 p-2 border rounded">
         <h3 class="pb-2 text-sm font-bold text-gray-700">
          {{ $t("callqueueTable.dateSelected") }}
         </h3>
         <div class="grid grid-cols-5">
          <p
           v-for="date in this.form.fullDates"
           :key="date"
           class="block text-sm text-gray-700">
           {{ date }}
          </p>
         </div>
         <label
          for="reference"
          class="block pt-5 text-sm font-normal text-gray-700 capitalize"
          >{{ $t("callqueueTable.reference") }}</label
         >
         <input
          v-model="this.form.reference"
          required
          type="text"
          name="reference"
          id="reference"
          autocomplete="reference"
          class="block w-full mt-1 border-gray-300 rounded focus:encom_border_input sm:text-sm" />
        </div>
       </div>
       <div
        v-if="this.openTimeSlotForm && this.weekDay"
        class="col-span-3 p-2 border rounded">
        <label
         for="weekdays"
         class="block pb-2 text-sm font-bold text-gray-700"
         >{{ $t("callqueueTable.daySelected") }}</label
        >
        <p
         class="block pb-1 text-sm text-gray-700 capitalize"
         v-if="this.form.dayOfWeek.length === 0 && !checked">
         None
        </p>
        <div class="grid grid-flow-col grid-rows-3" v-if="!checked">
         <p
          v-for="id in this.form.dayOfWeek"
          :key="id"
          class="block pb-1 text-sm text-gray-700 capitalize">
          {{ $t(this.weekDays[id - 1].day) }}
         </p>
        </div>
        <div class="grid grid-flow-col grid-rows-3" v-if="checked">
         <p
          v-for="dayOfWeek in weekDays"
          :key="dayOfWeek.id"
          class="block pb-1 text-sm text-gray-700 capitalize">
          {{ $t(dayOfWeek.day) }}
         </p>
        </div>
       </div>
       <div v-if="openTimeSlotForm" class="col-span-3 sm:col-span-3">
        <label
         for="start-timeslot"
         class="block text-sm font-bold text-gray-700 capitalize">
         {{ $t("callqueueTable.start") }}
        </label>
        <div class="relative mt-1 rounded shadow-sm">
         <input
          v-model="form.start"
          @input="validateTimeSlot()"
          type="time"
          required
          name="start-timeslot"
          id="start-timeslot"
          :class="inputClass('start')" />
         <ExclamationCircleIcon
          v-if="error.start"
          class="absolute inset-y-0 right-0 w-5 h-5 pr-3 text-red-500 pointer-events-none"
          aria-hidden="true" />
        </div>
        <p v-if="error.start" class="mt-1 ml-1 text-sm text-red-600">
         {{ error.start }}
        </p>
       </div>

       <div v-if="openTimeSlotForm" class="col-span-3 sm:col-span-3">
        <label
         for="end-timeslot"
         class="block text-sm font-bold text-gray-700 capitalize">
         {{ $t("callqueueTable.end") }}
        </label>
        <div class="relative mt-1 rounded shadow-sm">
         <input
          v-model="form.end"
          @input="validateTimeSlot()"
          type="time"
          required
          name="end-timeslot"
          id="end-timeslot"
          :class="inputClass('end')" />
         <ExclamationCircleIcon
          v-if="error.end"
          class="absolute inset-y-0 right-0 w-5 h-5 pr-3 text-red-500 pointer-events-none"
          aria-hidden="true" />
        </div>
        <p v-if="error.end" class="mt-1 ml-1 text-sm text-red-600">
         {{ error.end }}
        </p>
       </div>

       <div v-if="this.openTimeSlotForm && this.weekDay" class="col-span-6">
        <label
         for="reference"
         class="block text-sm font-normal text-gray-700 capitalize"
         >{{ $t("callqueueTable.reference") }}</label
        >
        <input
         v-model="this.form.reference"
         type="text"
         name="reference"
         id="reference"
         autocomplete="reference"
         class="block w-full mt-1 border-gray-300 rounded shadow-sm focus:encom_border_input sm:text-sm" />
       </div>

       <div v-if="this.openExceptionForm" class="col-span-3 capitalize">
        <v-date-picker
         :min-date="new Date()"
         :locale="$i18n.locale"
         v-model="this.form.day"
         @click="
          checkmakingOfBankHolidays(),
           checkmakingOfDate(),
           (this.closeNotification = true),
           (this.errorMessage = false)
         "
         title-position="left"
         trim-weeks
         is-expanded
         color="teal">
        </v-date-picker>
       </div>
       <div
        v-if="
         (this.openExceptionForm && this.form.day) ||
         (this.openExceptionForm && this.errorMessage)
        "
        class="col-span-3 p-2 border rounded">
        <h3 class="pb-2 text-lg font-semibold leading-6 text-gray-900">
         {{ $t("callqueueTable.dateSelected") }}
        </h3>
        <p class="block pb-2 text-base text-gray-700 capitalize">
         {{ this.fullFormatDateFrench(this.form.day) }}
        </p>

        <transition :name="computedTransition">
         <div
          v-if="this.closeNotification"
          :class="[
           !checkmakingOfDate() && !this.errorMessage
            ? 'rounded bg-green-50 p-4'
            : 'rounded bg-red-50 p-4',
          ]">
          <div class="flex">
           <div class="flex-shrink-0">
            <CheckCircleIcon
             v-show="!checkmakingOfDate() && !this.errorMessage"
             class="w-5 h-5 text-green-400"
             aria-hidden="true" />
            <XCircleIcon
             v-show="checkmakingOfDate() || this.errorMessage"
             class="w-5 h-5 text-red-400"
             aria-hidden="true" />
           </div>
           <div class="ml-3">
            <p
             :class="[
              !checkmakingOfDate() && !this.errorMessage
               ? 'text-sm font-medium text-green-800'
               : 'text-sm font-bold text-red-800',
             ]">
             {{
              !checkmakingOfDate() && !this.errorMessage
               ? $t("callqueueTable.newExceptionAdded")
               : $t("callqueueTable.newExceptionError")
             }}
            </p>

            <p v-show="checkmakingOfDate()" class="text-sm text-red-700">
             {{ $t("callqueueTable.newExceptionExist") }}.
            </p>
            <p v-show="this.errorMessage" class="text-sm text-red-700">
             {{ $t("callqueueTable.selectExceptionError") }}.
            </p>
           </div>
           <div class="pl-3 ml-auto">
            <div class="-mx-1.5 -my-1.5">
             <button
              type="button"
              @click="this.closeNotification = false"
              :class="[
               !checkmakingOfDate() && !this.errorMessage
                ? 'rounded inline-flex bg-green-50 rounded p-1.5 text-green-500 hover:bg-green-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-green-50 focus:ring-green-600'
                : 'rounded inline-flex bg-red-50 rounded p-1.5 text-red-500 hover:bg-red-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-red-50 focus:ring-red-600',
              ]">
              <span class="sr-only">Dismiss</span>
              <XIcon class="w-5 h-5" aria-hidden="true" />
             </button>
            </div>
           </div>
          </div>
         </div>
        </transition>
        <label
         for="reference"
         class="block pt-5 text-sm font-normal text-gray-700 capitalize"
         >{{ $t("callqueueTable.reference") }}</label
        >
        <input
         v-model="this.form.reference"
         required
         type="text"
         name="reference"
         id="reference"
         autocomplete="reference"
         class="block w-full mt-1 border-gray-300 rounded shadow-sm focus:encom_border_input sm:text-sm" />
       </div>
       <div
        v-if="
         !this.openBankHolidaysForm &&
         !this.call_queue_group_time_spans &&
         !groupView
        "
        class="col-span-6">
        <label
         for="street-address"
         class="block text-sm font-normal text-gray-700">
         Type de destination
        </label>
        <select
         v-model="destinationType"
         min="0"
         name="default_destination_type"
         id="default_destination_type"
         class="block w-full mt-1 border-gray-300 rounded shadow-sm focus:encom_border_input sm:text-sm">
         <option
          v-for="type in dest_type"
          :key="type.value"
          :value="type.value">
          {{ $t(type.name) }}
         </option>
        </select>
        <!-- <input
         v-model="this.form.destination"
         type="tel"
         name="destination"
         id="destination"
         autocomplete="destination"
         class="block w-full mt-1 border-gray-300 rounded shadow-sm focus:encom_border_input sm:text-sm"
        /> -->
        <!-- <p class="mt-2 text-sm text-gray-500">
         {{ $t("callqueueTable.destinationDescription") }}
        </p> -->
       </div>
       <div
        v-if="
         !this.openBankHolidaysForm &&
         !this.call_queue_group_time_spans &&
         !groupView
        "
        class="col-span-6">
        <label
         for="street-address"
         class="block text-sm font-normal text-gray-700 capitalize">
         Destination
        </label>
        <vue-select
         v-if="
          ruleType !== 'queue' &&
          (!this.form.destination_type ||
           this.form.destination_type === 'extension' ||
           this.form.destination_type === 'call_queue' ||
           this.form.destination_type === 'other' ||
           this.form.destination_type === 'voicemail')
         "
         v-model="searchDestNumber"
         :options="selectOptions"
         label-by="label"
         :close-on-select="true"
         :disabled="selectOptions?.length <= 0"
         searchable
         clear-on-select
         :multiple="false"
         :placeholder="$t('search')"
         max-height="140"
         class="block w-full py-1 mt-1 border-gray-300 rounded shadow-sm focus:encom_border_input sm:text-sm">
        </vue-select>
        <span v-if="destinationRequired" class="error"
         >La destination est requise pour les règles SDA.</span
        >
        <div
         v-else-if="
          ruleType === 'queue' &&
          this.form.destination_type !== 'external_number' &&
          this.form.destination_type !== 'end_call'
         ">
         <input
          v-model="searchDestNumber"
          type="text"
          name="default_destination"
          id="default_destination"
          class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6" />
        </div>
        <div v-else-if="this.form.destination_type === 'external_number'">
         <input
          v-model="searchDestNumber"
          type="text"
          name="default_destination"
          id="default_destination"
          :class="
           ({ 'is-invalid': phoneError },
           'block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6')
          " />
         <span v-if="phoneError" class="error">{{ phoneError }}</span>
        </div>
        <div v-else-if="this.form.destination_type === 'end_call'">
         <input
          v-model="searchDestNumber"
          type="text"
          name="default_destination"
          id="default_destination"
          disabled=""
          class="block w-full mt-1 bg-gray-200 border-gray-300 rounded shadow-sm cursor-not-allowed focus:encom_border_input sm:text-sm" />
        </div>
        <!-- <input
         v-model="this.form.destination"
         type="tel"
         name="destination"
         id="destination"
         autocomplete="destination"
         class="block w-full mt-1 border-gray-300 rounded shadow-sm focus:encom_border_input sm:text-sm" /> -->
        <p class="mt-2 text-sm text-gray-500">
         {{ $t("callqueueTable.destinationDescription") }}
        </p>
       </div>
       <div v-if="this.openBankHolidaysForm" class="col-span-6">
        <div>
         <h2 class="text-xs font-medium tracking-wide text-gray-500 uppercase">
          {{ $t("callqueueTable.nextFrenchHolidays") }}
         </h2>
         <ul
          role="list"
          class="grid grid-cols-1 gap-5 mt-3 sm:gap-6 sm:grid-cols-2 lg:grid-cols-4">
          <li
           v-for="(bankHolyday, title) in this.frenchHolidaysOver12Months"
           :key="bankHolyday.name"
           class="flex col-span-1 rounded shadow-sm">
           <div
            class="flex items-center justify-between flex-1 truncate bg-white border border-gray-200 rounded-md">
            <div class="flex-1 px-4 py-2 text-sm truncate">
             <p class="font-medium text-gray-900 hover:text-gray-600">
              {{ title }}
             </p>
             <p class="text-gray-500 capitalize">
              {{ $d(bankHolyday, "shortText") }}
             </p>
            </div>
           </div>
          </li>
         </ul>
        </div>
        <div class="p-4 mt-5 border-l-4 border-yellow-400 bg-yellow-50">
         <div class="flex">
          <div class="flex-shrink-0">
           <ExclamationIcon
            class="w-5 h-5 text-yellow-400"
            aria-hidden="true" />
          </div>
          <div class="ml-3">
           <p class="text-sm text-yellow-700">
            {{ $t("callqueueTable.addFrenchHolidaysWarning") }}.
            <b>{{ $t("callqueueTable.continue") }}</b>
           </p>
          </div>
         </div>
        </div>
       </div>
      </div>

      <div class="flex justify-end mt-5">
       <button
        @click="closeForm()"
        type="button"
        class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded hover:bg-gray-50">
        {{ $t("ticket.cancel") }}
       </button>
       <button
        type="submit"
        class="inline-flex justify-center px-4 py-2 ml-3 text-sm font-medium text-white capitalize border border-transparent rounded shadow-sm disabled body__table--header">
        {{ this.openBankHolidaysForm ? $t("dialog.confirm") : $t("validate") }}
       </button>
      </div>
     </form>
    </div>
   </div>
  </div>
 </div>
 <ask-confirmation-dialog ref="askConfirmationDialog"></ask-confirmation-dialog>
 <ComfirmationDialog
  v-if="this.showMessage"
  :messageToShow="this.messageToShow"
  :subMessageToShow="this.subMessageToShow" />
</template>

<script>
import axios from "axios";

import VueSelect from "vue-next-select";
import "vue-next-select/dist/index.css";

import {
 ExclamationIcon,
 ExclamationCircleIcon,
 CheckCircleIcon,
 SelectorIcon,
 XCircleIcon,
 XIcon,
} from "@heroicons/vue/solid";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/vue";
import AskConfirmationDialog from "../components/AskConfirmationDialog.vue";
import ComfirmationDialog from "../components/ConfirmationDialog.vue";
const account = localStorage.getItem("account");

const weekDays = [
 { id: 1, day: "weekdays.mon" },
 { id: 2, day: "weekdays.tue" },
 { id: 3, day: "weekdays.wed" },
 { id: 4, day: "weekdays.thu" },
 { id: 5, day: "weekdays.fri" },
 { id: 6, day: "weekdays.sat" },
 { id: 7, day: "weekdays.sun" },
];

const dest_type = [
 { name: "extension", value: "extension" },
 { name: "voicemail", value: "voicemail" },
 //  { name: "svi", value: "svi" },
 { name: "queue", value: "call_queue" },
 //  { name: "call flow", value: "call_flow" },
 { name: "end call", value: "end_call" },
 { name: "external number", value: "external_number" },
 { name: "other", value: "other" },
];

export default {
 name: "CreateNewCallQueueTimeSlot",
 props: [
  "openTimeSlotForm",
  "openExceptionForm",
  "openBankHolidaysForm",
  "call_queue_detail",
  "call_queue_id",
  "call_queue_group_id",
  "call_queue_group",
  "call_queue_exceptions",
  "call_queue_time_spans",
  "call_queue_group_time_spans",
  "call_queue_group_exceptions",
  "formatDateFrench",
  "fullFormatDateFrench",
  "extensionOptions",
  "queueOptions",
  "othersOptions",
  "groupView",
  "ruleType",
 ],
 components: {
  CheckCircleIcon,
  ExclamationIcon,
  ExclamationCircleIcon,
  SelectorIcon,
  XCircleIcon,
  XIcon,
  ComfirmationDialog,
  AskConfirmationDialog,
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
  VueSelect,
 },
 setup() {
  return {
   weekDays,
  };
 },
 data() {
  return {
   destinationRequired: false,
   dayClicked: false,
   destinationType: "",
   selectOptions: [],
   selectOptionsNumbers: [],
   phoneError: null,
   searchDestNumber: "",
   destNumber: null,
   searchNumber: "",
   dest_type,
   account,
   form: {
    destination_type: null,
    day: "",
    dayOfWeek: [],
    fullDates: [],
    start: "",
    end: "",
    destination: null,
    reference: null,
   },
   weekDay: true,
   specificDay: false,
   days: [],
   pickedStartBigger: false,
   checked: false,
   showMessage: false,
   errorMessage: false,
   closeNotification: true,
   withTransition: true,
   messageToShow: "",
   subMessageToShow: "",
   frenchHolidaysOver12Months: {},
   frenchHolidaysDateOver12Months: [],
   callQueuesOptions: null,
   error: {
    start: "",
    end: "",
   },
  };
 },
 computed: {
  computedTransition() {
   return this.withTransition && "fade";
  },
  dates() {
   return this.days.map(day => day.date);
  },
  attributes() {
   if (this.days.length <= 0) {
    return null;
   }
   return this.dates.map(date => ({
    highlight: true,
    dates: date,
   }));
  },
 },
 methods: {
  async getCallQueuesOptions() {
   const res = await axios.get(
    `${this.$cookie.getCookie(
     "API"
    )}/api/v1/callQueues/options?customerAccount=${this.account}`,
    {
     headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
     },
    }
   );

   try {
    if (res.data && res.data.hosts) {
     this.fillDest(res.data.hosts);
    }
   } catch (error) {
    this.errorHandling(error);
   }
  },

  async getFrenchHolidaysOver12Months() {
   const res = await axios.get(
    `${this.$cookie.getCookie(
     "API"
    )}/api/v1/helpers/time/frenchHolidaysOver12Months`,
    {
     headers: {
      "Content-Type": "application/json",
     },
    }
   );

   try {
    this.frenchHolidaysOver12Months = res.data.response;
    for (const key in this.frenchHolidaysOver12Months) {
     if (Object.hasOwnProperty.call(this.frenchHolidaysOver12Months, key)) {
      this.frenchHolidaysDateOver12Months.push(
       this.frenchHolidaysOver12Months[key]
      );
     }
    }
   } catch (error) {
    this.errorHandling(error);
    this.$emit("activeBanner");
    this.$emit("success", false);
    this.$emit("successMsg", this.errorDataResponse);
   }
  },
  async createTimeSlot(msg, title, confirmationMessage, confirmButton, goBack) {
   let ruleType = this.call_queue_detail?.type;
   if (this.weekDay) {
    this.form.fullDates = [];
   }
   if (this.specificDay) {
    this.checked = false;
    this.form.dayOfWeek = [];
   }
   if (this.call_queue_group_time_spans) {
    if (this.checked) {
     //create a timeslot for a call queue group and for all the day
     const options = {
      method: "POST",
      url: `${this.$cookie.getCookie("API")}/api/v1/callQueueGroupTimeSpans`,
      params: {
       customerAccount: this.account,
       call_queue_group_id: this.call_queue_group_id,
      },
      headers: {
       "Content-Type": "application/json",
       Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      data: {
       daysOfWeek: [1, 2, 3, 4, 5, 6, 7],
       start: this.form.start,
       end: this.form.end,
       reference: this.form.reference,
      },
     };

     axios
      .request(options)
      .then(res => {
       this.$emit("activeBanner");
       this.$emit("success", true);
       this.$emit("successMsg", msg);
       this.cleanForm();
      })
      .catch(error => {
       this.errorHandling(error);
       this.$emit("activeBanner");
       this.$emit("success", false);
       this.$emit(
        "successMsg",
        this.errorDataResponse.includes(
         "bad request: timespans have conflicts with"
        )
         ? this.$t("timeSpanConflictError")
         : this.errorDataResponse
       );
      });
    } else {
     //create a timeslot for a call queue group and for days specified by the user
     const options = {
      method: "POST",
      url: `${this.$cookie.getCookie("API")}/api/v1/callQueueGroupTimeSpans`,
      params: {
       customerAccount: this.account,
       call_queue_group_id: this.call_queue_group_id,
      },
      headers: {
       "Content-Type": "application/json",
       Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      data: {
       daysOfWeek:
        this.form.fullDates && this.form.fullDates.length > 0
         ? []
         : this.form.dayOfWeek,
       fullDates:
        this.form.dayOfWeek && this.form.dayOfWeek.length > 0
         ? []
         : this.form.fullDates,
       start: this.form.start,
       end: this.form.end,
       reference: this.form.reference,
      },
     };

     axios
      .request(options)
      .then(res => {
       this.$emit("activeBanner");
       this.$emit("success", true);
       this.$emit("successMsg", msg);
       this.cleanForm();
      })
      .catch(error => {
       this.errorHandling(error);
       this.$emit("activeBanner");
       this.$emit("success", false);
       this.$emit(
        "successMsg",
        this.errorDataResponse.includes(
         "bad request: timespans have conflicts with"
        )
         ? this.$t("timeSpanConflictError")
         : this.errorDataResponse
       );
      });
    }
   } else {
    this.destinationRequired = false;
    if (ruleType === "did" && !this.form.destination) {
     return (this.destinationRequired = true);
    }
    if (this.call_queue_group) {
     if (this.checked) {
      //create a timeslot for a call queue and for all the day
      const options = {
       method: "POST",
       url: `${this.$cookie.getCookie("API")}/api/v1/callQueueTimeSpans`,
       params: {
        customerAccount: this.account,
        call_queue_id: this.call_queue_id,
       },
       headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
       },
       data: {
        destination_type: this.form.destination_type,
        destination: this.form.destination,
       },
      };
      //display warning window if this callqueue is link to a callqueue group
      if (false) {
       const r = await this.$refs.askConfirmationDialog.show({
        title: title,
        message: confirmationMessage,
        okButton: confirmButton,
        cancelButton: goBack,
        action: "delete",
       });
       if (r) {
        this.unlinkCallQueue();
        axios
         .request(options)
         .then(res => {
          this.$emit("activeBanner");
          this.$emit("success", true);
          this.$emit("successMsg", msg);
          this.cleanForm();
         })
         .catch(error => {
          this.errorHandling(error);
          this.$emit("activeBanner");
          this.$emit("success", false);
          this.$emit("successMsg", this.errorDataResponse);
         });
       }
      } else {
       axios
        .request(options)
        .then(res => {
         this.$emit("activeBanner");
         this.$emit("success", true);
         this.$emit("successMsg", msg);
         this.cleanForm();
        })
        .catch(error => {
         this.errorHandling(error);
         this.$emit("activeBanner");
         this.$emit("success", false);
         this.$emit(
          "successMsg",
          this.errorDataResponse.includes(
           "bad request: timespans have conflicts with"
          )
           ? this.$t("timeSpanConflictError")
           : this.errorDataResponse
         );
        });
      }
     } else {
      //  return console.log(this.form);
      //create a timeslot for a call queue and for days specified by the user
      const options = {
       method: "POST",
       url: `${this.$cookie.getCookie("API")}/api/v1/callQueueTimeSpans`,
       params: {
        customerAccount: this.account,
        call_queue_id: this.call_queue_id,
       },
       headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
       },
       data: {
        destination_type: this.form.destination_type,
        destination: this.form.destination,
       },
      };
      //display warning window if this callqueue is link to a callqueue group

      axios
       .request(options)
       .then(res => {
        this.$emit("activeBanner");
        this.$emit("success", true);
        this.$emit("successMsg", msg);
        this.cleanForm();
       })
       .catch(error => {
        this.errorHandling(error);
        this.$emit("activeBanner");
        this.$emit("success", false);
        this.$emit(
         "successMsg",
         this.errorDataResponse.includes(
          "bad request: timespans have conflicts with"
         )
          ? this.$t("timeSpanConflictError")
          : this.errorDataResponse
        );
       });
     }
    } else {
     if (this.checked) {
      //create a timeslot for a call queue and for all the day
      const options = {
       method: "POST",
       url: `${this.$cookie.getCookie("API")}/api/v1/callQueueTimeSpans`,
       params: {
        customerAccount: this.account,
        call_queue_id: this.call_queue_id,
       },
       headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
       },
       data: {
        daysOfWeek: [1, 2, 3, 4, 5, 6, 7],
        start: this.form.start,
        end: this.form.end,
        reference: this.form.reference,
        destination_type: this.form.destination_type,
        destination: this.form.destination,
       },
      };
      //display warning window if this callqueue is link to a callqueue group
      if (false) {
       const r = await this.$refs.askConfirmationDialog.show({
        title: title,
        message: confirmationMessage,
        okButton: confirmButton,
        cancelButton: goBack,
        action: "delete",
       });
       if (r) {
        this.unlinkCallQueue();
        axios
         .request(options)
         .then(res => {
          this.$emit("activeBanner");
          this.$emit("success", true);
          this.$emit("successMsg", msg);
          this.cleanForm();
         })
         .catch(error => {
          this.errorHandling(error);
          this.$emit("activeBanner");
          this.$emit("success", false);
          this.$emit("successMsg", this.errorDataResponse);
         });
       }
      } else {
       axios
        .request(options)
        .then(res => {
         this.$emit("activeBanner");
         this.$emit("success", true);
         this.$emit("successMsg", msg);
         this.cleanForm();
        })
        .catch(error => {
         this.errorHandling(error);
         this.$emit("activeBanner");
         this.$emit("success", false);
         this.$emit(
          "successMsg",
          this.errorDataResponse.includes(
           "bad request: timespans have conflicts with"
          )
           ? this.$t("timeSpanConflictError")
           : this.errorDataResponse
         );
        });
      }
     } else {
      //  return console.log(this.form);
      //create a timeslot for a call queue and for days specified by the user
      const options = {
       method: "POST",
       url: `${this.$cookie.getCookie("API")}/api/v1/callQueueTimeSpans`,
       params: {
        customerAccount: this.account,
        call_queue_id: this.call_queue_id,
       },
       headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
       },
       data: {
        daysOfWeek:
         this.form.fullDates && this.form.fullDates.length > 0
          ? []
          : this.form.dayOfWeek,
        fullDates:
         this.form.dayOfWeek && this.form.dayOfWeek.length > 0
          ? []
          : this.form.fullDates,
        start: this.form.start,
        end: this.form.end,
        reference: this.form.reference,
        destination_type: this.form.destination_type,
        destination: this.form.destination,
       },
      };
      //display warning window if this callqueue is link to a callqueue group
      axios
       .request(options)
       .then(res => {
        this.$emit("activeBanner");
        this.$emit("success", true);
        this.$emit("successMsg", msg);
        this.cleanForm();
       })
       .catch(error => {
        this.errorHandling(error);
        this.$emit("activeBanner");
        this.$emit("success", false);
        this.$emit(
         "successMsg",
         this.errorDataResponse.includes(
          "bad request: timespans have conflicts with"
         )
          ? this.$t("timeSpanConflictError")
          : this.errorDataResponse
        );
       });
     }
    }
   }
  },
  async createException(
   msg,
   title,
   confirmationMessage,
   confirmButton,
   goBack
  ) {
   if (this.call_queue_group_exceptions) {
    //create an exception for a call queue group
    const options = {
     method: "POST",
     url: `${this.$cookie.getCookie("API")}/api/v1/callQueueGroupExceptions`,
     params: {
      customerAccount: this.account,
      call_queue_group_id: this.call_queue_group_id,
     },
     headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
     },
     data: {
      day: this.form.day,
      reference: this.form.reference,
      destination: this.form.destination,
      destination_type: this.form.destination_type,
     },
    };
    if (this.form.day && !this.checkmakingOfDate()) {
     axios
      .request(options)
      .catch(err => {
       if (err.response) {
        if (err.response.status == 500) {
         window.alert(
          "Oups, something went wrong...\nReason: " + err.response.statusText
         );
        } else if (err.response.status == 404) {
         window.alert("Document " + err.response.statusText);
        }
       }
      })
      .then(res => {
       this.$emit("activeBanner");
       this.$emit("success", true);
       this.$emit("successMsg", msg);
       this.cleanForm();
      });
    } else if (!this.form.day) {
     this.errorMessage = true;
    } else {
    }
   } else {
    //create an exception for one call queue
    const options = {
     method: "POST",
     url: `${this.$cookie.getCookie("API")}/api/v1/callQueueExceptions`,
     params: {
      customerAccount: this.account,
      call_queue_id: this.call_queue_id,
     },
     headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
     },
     data: {
      day: this.form.day,
      destination: this.form.destination,
      reference: this.form.reference,
      // destination: this.form.destination,
      // destination: this.form.destination,
      destination_type: this.form.destination_type,
     },
    };
    //display warning window if this callqueue is link to a callqueue group
    if (this.call_queue_group) {
     const r = await this.$refs.askConfirmationDialog.show({
      title: title,
      message: confirmationMessage,
      okButton: confirmButton,
      cancelButton: goBack,
      action: "delete",
     });
     if (r) {
      this.unlinkCallQueue();
      if (this.form.day && !this.checkmakingOfDate()) {
       axios
        .request(options)
        .catch(err => {
         if (err.response) {
          if (err.response.status == 500) {
           window.alert(
            "Oups, something went wrong...\nReason: " + err.response.statusText
           );
          } else if (err.response.status == 404) {
           window.alert("Document " + err.response.statusText);
          }
         }
        })
        .then(res => {
         this.$emit("activeBanner");
         this.$emit("success", true);
         this.$emit("successMsg", msg);
         this.cleanForm();
        });
      } else if (!this.form.day) {
       this.errorMessage = true;
      } else {
      }
     }
    } else {
     if (this.form.day && !this.checkmakingOfDate()) {
      axios
       .request(options)
       .catch(err => {
        if (err.response) {
         if (err.response.status == 500) {
          window.alert(
           "Oups, something went wrong...\nReason: " + err.response.statusText
          );
         } else if (err.response.status == 404) {
          window.alert("Document " + err.response.statusText);
         }
        }
       })
       .then(res => {
        this.$emit("activeBanner");
        this.$emit("success", true);
        this.$emit("successMsg", msg);
        this.cleanForm();
       });
     } else if (!this.form.day) {
      this.errorMessage = true;
     } else {
     }
    }
   }
  },
  async createExceptionForBankHolidays(
   msg,
   title,
   confirmationMessage,
   confirmButton,
   goBack
  ) {
   //create 12 exception (12 following french bank holidays) for a call queue group
   if (this.call_queue_group_exceptions) {
    const options = {
     method: "POST",
     url: `${this.$cookie.getCookie(
      "API"
     )}/api/v1/callQueueGroupExceptions/holidays`,
     params: {
      customerAccount: this.account,
      call_queue_group_id: this.call_queue_group_id,
     },
     headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
     },
    };
    axios
     .request(options)
     .then(res => {
      this.$emit("activeBanner");
      this.$emit("success", true);
      this.$emit("successMsg", msg);
     })
     .catch(err => {
      this.$emit("activeBanner");
      this.$emit("success", false);
      this.$emit("successMsg", err.response.statusText);
     });
   } else {
    const options = {
     method: "POST",
     url: `${this.$cookie.getCookie(
      "API"
     )}/api/v1/callQueueExceptions/holidays`,
     params: {
      customerAccount: this.account,
      call_queue_id: this.call_queue_id,
     },
     headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
     },
    };

    //display warning window if this callqueue is link to a callqueue group
    if (this.call_queue_group) {
     const r = await this.$refs.askConfirmationDialog.show({
      title: title,
      message: confirmationMessage,
      okButton: confirmButton,
      cancelButton: goBack,
      action: "delete",
     });
     if (r) {
      this.unlinkCallQueue();
      axios
       .request(options)
       .catch(err => {
        if (err.response) {
         if (err.response.status == 500) {
          window.alert(
           "Oups, something went wrong...\nReason: " + err.response.statusText
          );
         } else if (err.response.status == 404) {
          window.alert("Document " + err.response.statusText);
         }
        }
       })
       .then(res => {
        this.$emit("activeBanner");
        this.$emit("success", true);
        this.$emit("successMsg", msg);
       });
     }
    } else {
     axios
      .request(options)
      .catch(err => {
       if (err.response) {
        if (err.response.status == 500) {
         window.alert(
          "Oups, something went wrong...\nReason: " + err.response.statusText
         );
        } else if (err.response.status == 404) {
         window.alert("Document " + err.response.statusText);
        }
       }
      })
      .then(res => {
       this.$emit("activeBanner");
       this.$emit("success", true);
       this.$emit("successMsg", msg);
      });
    }
   }
  },
  unlinkCallQueue() {
   const options = {
    method: "PUT",
    url: `${this.$cookie.getCookie("API")}/api/v1/callQueues/unlink`,
    params: {
     customerAccount: this.account,
     callQueueId: this.call_queue_detail.id,
    },
    headers: {
     "Content-Type": "application/json",
     Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
   };
   axios.request(options).catch(error => {
    this.errorHandling(error);
    this.$emit("activeBanner");
    this.$emit("success", false);
    this.$emit("successMsg", this.errorDataResponse);
   });
  },
  checkmakingOfDate() {
   if (this.call_queue_group_exceptions) {
    let pickedDay =
     JSON.stringify(this.form.day).slice(1, 11) + "T00:00:00.000000Z";
    let day = this.call_queue_group_exceptions.find(
     day => day.day === pickedDay
    );
    if (day) {
     return true;
    } else {
     return false;
    }
   } else {
    let pickedDay =
     JSON.stringify(this.form.day).slice(1, 11) + "T00:00:00.000000Z";
    let day = this.call_queue_exceptions.find(day => day.day === pickedDay);
    if (day) {
     return true;
    } else {
     return false;
    }
   }
  },
  checkmakingOfBankHolidays() {
   this.form.reference = null;
   let pickedDay =
    JSON.stringify(this.form.day).slice(1, 11) + "T00:00:00.000000Z";
   let bankHolyday = this.frenchHolidaysDateOver12Months.find(
    bankHolyday =>
     this.formatDateFrench(bankHolyday) === this.formatDateFrench(pickedDay)
   );
   for (const [frenchHolidays, date] of Object.entries(
    this.frenchHolidaysOver12Months
   )) {
    if (date === bankHolyday) {
     this.form.reference = frenchHolidays;
    }
   }
  },
  validateTimeSlot() {
   const { start, end } = this.form;
   this.error.start = "";
   this.error.end = "";
   this.pickedStartBigger = false;

   if (start >= end) {
    this.pickedStartBigger = true;
    this.error.start = this.$t("callqueueTable.pickedStartBigger");
    return;
   }

   const conflicts = this.checkmakingTimeSlot();
   if (conflicts.checkStart)
    this.error.start = this.$t("callqueueTable.checkStart");
   if (conflicts.checkEnd) this.error.end = this.$t("callqueueTable.checkEnd");
   if (conflicts.checkBetween) {
    this.error.start = this.$t("callqueueTable.checkBetween");
    this.error.end = this.$t("callqueueTable.checkBetween");
   }
  },
  checkmakingTimeSlot() {
   const { start, end, fullDates, dayOfWeek } = this.form;
   const pickedDays = this.specificDay ? fullDates : dayOfWeek;
   const checkDay = [];
   let checkStart, checkEnd, checkBetween;

   const getRelevantSpans = dateOrDay =>
    this.specificDay
     ? this.call_queue_group_time_spans?.filter(
        span => span.fullDate === dateOrDay
       )
     : this.call_queue_group_time_spans?.filter(
        span => span.dayOfWeek === dateOrDay
       );

   const findOverlap = timeSpans => {
    checkStart = timeSpans.find(
     span => start >= span.start.slice(0, 5) && start <= span.end.slice(0, 5)
    );
    checkEnd = timeSpans.find(
     span => end >= span.start.slice(0, 5) && end <= span.end.slice(0, 5)
    );
    checkBetween = timeSpans.find(
     span => start <= span.start.slice(0, 5) && end >= span.end.slice(0, 5)
    );
   };

   const formatDateString = dateStr => {
    // Split the DD/MM/YYYY format and rearrange it to YYYY-MM-DD
    const [day, month, year] = dateStr.split("/");
    return `${year}-${month}-${day}`;
   };

   pickedDays.forEach(value => {
    console.log("value date", value);
    const dateOrDay = this.specificDay
     ? new Date(formatDateString(value)).toISOString().split("T")[0]
     : value;
    const timeSpans = getRelevantSpans(dateOrDay);
    if (timeSpans?.length > 0) {
     findOverlap(timeSpans);
     checkDay.push(...timeSpans);
    }
   });

   return { checkStart, checkEnd, checkBetween };
  },
  inputClass(field) {
   return [
    "mt-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded",
    this.error[field]
     ? "ring-red-500 border-red-300 focus:ring-red-500 focus:border-red-500"
     : "",
   ].join(" ");
  },
  sendMessage(msg, subMsg) {
   this.showMessage = true;
   this.messageToShow = msg;
   this.subMessageToShow = subMsg;
  },
  sendErrorMessage() {
   this.errorMessage = true;
   this.messageToShow = "Sorry, something went wrong";
   this.subMessageToShow = "Select an exception date in the calendar";
  },
  closeForm() {
   this.cleanForm();
   this.$emit("closeForm");
  },
  cleanForm() {
   this.checked = false;
   this.form.dayOfWeek = [];
   this.form.fullDates = [];
   this.form.day = "";
   this.form.start = "";
   this.form.end = "";
   this.form.destination = null;
   this.form.reference = "";
   this.form.destination_type = null;
   this.days = [];
   this.destinationType = "";
   this.searchDestNumber = "";
   this.destNumber = "";
   this.searchNumber = "";
   this.attributes = [];
   this.selectOptions = [];
  },
  switchTabs() {
   if (!this.weekDay) {
    this.weekDay = !this.weekDay;
    this.specificDay = false;
    this.form.dayOfWeek = [];
    this.form.day = "";
    this.form.start = "";
    this.form.end = "";
    this.form.destination = "";
    this.form.reference = "";
   }
  },
  switchTabs2() {
   if (!this.specificDay) {
    this.specificDay = !this.specificDay;
    this.weekDay = false;
    this.form.fullDates = [];
    this.days = [];
    this.attributes = [];
    this.form.day = "";
    this.form.start = "";
    this.form.end = "";
    this.form.destination = "";
    this.form.reference = "";
   }
  },
  onDayClick(day) {
   this.dayClicked = !this.dayClicked;
   const idx = this.form.fullDates.findIndex(
    d => d === this.formatDateFrench(day.date)
   );
   const datesIdx = this.days.findIndex(d => d.id === day.id);
   if (datesIdx >= 0) {
    this.days.splice(datesIdx, 1);
   } else {
    this.days.push({
     id: day.id,
     date: day.date,
    });
   }
   if (idx >= 0) {
    this.form.fullDates.splice(idx, 1);
   } else {
    this.form.fullDates.push(this.formatDateFrench(day.date));
   }
  },
 },
 watch: {
  searchDestNumber: function (val) {
   if (this.form.destination_type === "external_number") {
    this.validatePhoneNumber();
    this.destNumber = val;
    this.form.destination = val;
   } else {
    this.destNumber = val?.value;
    this.form.destination = val?.value;
   }
  },
  destinationType: function (val) {
   this.form.destination_type = val;
   switch (val) {
    case "extension":
     this.selectOptions = this.extensionOptions ? this.extensionOptions : [];
     break;
    case "voicemail":
     this.selectOptions = this.extensionOptions ? this.extensionOptions : [];
     break;
    case "svi":
     // this.selectOptions = extensions;
     break;
    case "call_queue":
     this.selectOptions = this.queueOptions ? this.queueOptions : [];
     break;
    case "call_flow":
     // this.selectOptions = extensions;
     break;
    case "end_call":
     // this.selectOptions = extensions;
     break;
    case "other":
     this.selectOptions = this.othersOptions ? this.othersOptions : [];
     break;
    case "external_number":
     this.searchDestNumber = "";
     // this.selectOptions = extensions;
     break;
    default:
     console.log("Unknown action");
     break;
   }
  },
 },
 mounted() {
  this.getFrenchHolidaysOver12Months();
  // this.getCallQueuesOptions();
 },
};
</script>

<style scoped>
.fade-leave-active {
 transition: opacity 0.5s;
}
.fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
 opacity: 0;
}
.is-invalid {
 border: 1px solid red !important;
 /* border-color: red !important; */
}
.error {
 color: red;
 font-size: 0.875em;
}
</style>
